import React from 'react';
import '../App.css';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Grommet, Box } from 'grommet';
import Typography from '@mui/material/Typography';
import 'typeface-roboto';

const useStyles = {


  large: {

    margin: 28
  },
  cardRoot: {
    minWidth: 275,
    outlineColor: "#FF0000",
    outlineWidth: 24
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
};

function About() {
  const classes = useStyles;
  return (
    <Grommet plain>

      <header className="App-header" style={{ shadows: ["none"], padding: 2, background: '#212121', backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>

        <Box
          pad="none"
          style={{ margin: 10 }}
          animation="fadeIn">
          <Card styles={{
            minWidth: 275,
            outlineColor: "#FF0000",
            outlineWidth: 24
          }}
            variant="outlined">
            <CardContent>
              <Typography className={classes.title} color="textSecondary" gutterBottom>
                About This Website
              </Typography>

              <Typography variant="h5" component="h2">
                Developed by Jatin Arora
                Built with React
              </Typography>

              <Typography variant="body2" component="span">
                UI Frameworks
                <a href="https://v2.grommet.io/">Grommet</a>
              </Typography>
              <Typography variant="body2" component="span">
                <a href="https://react-bootstrap.github.io/">React Bootstrap</a>
              </Typography>
              <Typography variant="body2" component="span">
                <a href="https://material-ui.com/">Material UI</a>
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </header>


    </Grommet>
  );
}

export default About;